import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";

import * as ajax from "helpers/ajax";




export default class FileSystemGara extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data
        };
    }

    render() {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={this.state.data.name}
                    backButton={this.props.backFunction}
                />
                <FileSystem
                    id={this.state.data.id}
                    baseRoute={"/gara"}
                />
            </DashboardLayout>
        )
    }
}


